// Colour scale shown under the heatmap board. Four discrete swatches — the
// exact ramp stops the cards use (heatmapCells.ts): bright red = severe
// trouble, dark red = mild trouble, dark green = a short call, bright green
// = a long-running call. Discretised (not a continuous gradient) and kept
// compact so the eye reads it at a glance instead of scanning a full-width bar.

const SWATCHES = ['#ef4444', '#7f1d1d', '#1f7a4d', '#4ade80']

export function HeatmapLegend() {
  return (
    <div className="flex shrink-0 items-center justify-center gap-2 text-xs text-gray-400">
      <span className="font-medium uppercase tracking-wide">Проблема</span>
      <div className="flex gap-0.5" aria-hidden="true">
        {SWATCHES.map((c) => (
          <div key={c} className="h-2.5 w-6 rounded-sm" style={{ background: c }} />
        ))}
      </div>
      <span className="font-medium uppercase tracking-wide">Активность</span>
    </div>
  )
}
